export default __webpack_public_path__ + "static/media/siniestro.a1a6f1d6.svg";